import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-footer-boyd-reward',
  templateUrl: './footer-boyd-reward.component.html',
  styleUrls: ['./footer-boyd-reward.component.scss'],
})
export class FooterBoydRewardComponent implements OnInit {

  public playerHasRewardCard: boolean = null;
  protected isAuthenticated: boolean = false;
  public isIOSMobile:boolean = false;
  constructor(
    private navigator: Navigator,
    private userSessionService: UserSessionService,
    private authenticationService: AuthenticationService,
    private platform: Platform
  ) { 
    this.isIOSMobile =  this.platform.is('ios') && this.platform.is('mobile');
  }

  ngOnInit() {}

  private checkPlayerHasRewardCard(){
    this.authenticationService.checkPlayerHasRewardCard().subscribe(
         (response) => {
           if (response && !!response.result) {
             this.playerHasRewardCard = response.payload;
             if(this.playerHasRewardCard){
              this.navigator.navigateTo('BoydRewardsLaunchComponent', { customModalClass: 'app-restricted-screen', animated: false });
            } else {
              this.navigator.navigateTo('BoydRewardsCardOrOnline', { customModalClass: 'crown-modal' });
            }
           }
         },
         (error) => {
           this.playerHasRewardCard = false;
         }
    );
 }

  checkUserStatusForBoydCard(){
      this.userSessionService.isAuthenticated().then((auth) => {
        if (auth){
          this.checkPlayerHasRewardCard();
        } else {
          return this.navigator.navigateTo('BoydRewardsCardOrOnline', { customModalClass: 'crown-modal' });
        }
      })
  }

}
